import type { MenuGroup } from './menu';

/** Expose diagnostics alongside the import page to users granted that page. */
export function withMasterDataEntry(groups: MenuGroup[]): MenuGroup[] {
  if (groups.some((g) => g.items.some((item) => item.url === '/master-data'))) return groups;
  return groups.map((group) => {
    const source = group.items.find((item) => item.url === '/legacy/import-masterdata');
    if (!source) return group;
    return {
      ...group,
      items: [
        ...group.items,
        {
          ...source,
          id: -42,
          labelKey: 'WTK_MASTERDATA_DIAGNOSTICS_TITLE',
          url: '/master-data',
          app: 'portal-v2',
          internal: true,
        },
      ],
    };
  });
}
